import axios from "@/common/axios";
import qs from "qs";

export function login(data) {
  return axios({
    method: "post",
    url: "/login",
    data: qs.stringify(data),
  });
}

export function registerAdd(data) {
  return axios({
    method: "post",
    url: "/register/add",
    data: qs.stringify(data),
  });
}
